module.exports = __webpack_public_path__ + "img/TESTSHOP.8366bbaa.svg";